import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
import Badge from "@insite/mobius/Badge";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
	badgeList: BadgeModel[];
	maxBadges: number;
	extendedStyles?: ProductTextBadgesStyles;
}

const mapStateToProps = (state: CustomApplicationState) => {
	const customSettings = state.context.settings.properties;
	return {
		userRoles: state.context.session.userRoles,
		customBuyerRoleName: customSettings?.customBuyerRoleName || "",
	}
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface ProductTextBadgesStyles {
	container?: InjectableCss;
	badge?: InjectableCss;
	badgeText?: TypographyPresentationProps;
}

export const productTextBadgesStyles: ProductTextBadgesStyles = {
	badge: {
		css: css`
			margin-top: 5px;
		`,
	},
	badgeText: {
		weight: "bold",
		size: 15,
		css: css`
			width: 100%;
			margin: auto;
			${wrapInContainerStyles}
		`,
	},
};

const ProductTextBadges = ({ badgeList, maxBadges, extendedStyles, userRoles, customBuyerRoleName }: Props) => {
	const [styles] = useState(() => mergeToNew(productTextBadgesStyles, extendedStyles));

	if (userRoles && userRoles.toLowerCase().includes(customBuyerRoleName.toLowerCase())) {
		return null;
	}

	return (
		<StyledWrapper {...styles.container} data-test-selector="textBadges">
			{badgeList.slice(0, maxBadges).map(badge => (
				<StyledWrapper 
				key={badge.id} 
				{...styles.badge} 
				css={badge.badgeStyle === "Rectangle" ? css`
					div[class^="TextBadge"] {
						text-align: left !important;
						padding: 4px 10px !important;
						margin: 5px 0px !important;
						border-left: 5px solid ${WhitecapColors.badgeBorderColor};
					}
 					` : undefined}>
						<Badge
							type={badge.badgeType}
							value={badge.displayText}
							badgeTextColor={badge.textColorHexCode}
							badgeBackgroundColor={badge.badgeColorHexCode}
							badgeTextRounding={badge.badgeStyle === "Round" ? 20 : 0}
							textBadgeCss={styles.badgeText}
							{...styles.badge}
						/>
				</StyledWrapper>
			))}
		</StyledWrapper>
	);
};

export default connect(mapStateToProps)(ProductTextBadges);
